import { useState, useCallback } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './styles.scss';

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' }
    ],
    ['link'],
    ['clean'],
    [{ direction: 'rtl' }]
  ]
};

export const RichTextEditor = ({ value = '', onChange, children, ...rest }) => {
  const [editorValue, setEditorValue] = useState(value);

  // Debounce function to delay onChange execution
  const debounce = (fn, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  };

  // Debounced onChange handler
  const debouncedOnChange = useCallback(
    debounce((content) => {
      if (onChange) {
        onChange(content); // Call external onChange only after debounce delay
      }
    }, 500), // Delay in milliseconds
    [onChange]
  );

  const handleChange = (content) => {
    setEditorValue(content); // Update local state immediately
    debouncedOnChange(content); // Trigger debounced onChange
  };

  const commonProps = {
    value: editorValue,
    onChange: handleChange,
    modules: modules,
    theme: 'snow',
    ...rest
  };

  return children
    ? renderWithCustomTextArea(commonProps, children)
    : renderWithDefaultEditor(commonProps);
};

function renderWithDefaultEditor(commonProps) {
  return <ReactQuill {...commonProps} />;
}

function renderWithCustomTextArea(commonProps, customTextAreaComp) {
  return <ReactQuill {...commonProps}>{customTextAreaComp}</ReactQuill>;
}
